/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Intro_P2Inputs */

const es_exp_mk_intro_p2 = /** @type {(inputs: Exp_Mk_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para el armador, es la forma más sencilla de usar el barco más a menudo y conocer a gente que comparte la pasión por el mar.`)
};

const gl_exp_mk_intro_p2 = /** @type {(inputs: Exp_Mk_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para o armador, é a forma máis sinxela de usar o barco máis a miúdo e coñecer xente que comparte a paixón polo mar.`)
};

const en_exp_mk_intro_p2 = /** @type {(inputs: Exp_Mk_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For owners, it is the easiest way to use the boat more often and meet people who share a passion for the sea.`)
};

/**
* | output |
* | --- |
* | "For owners, it is the easiest way to use the boat more often and meet people who share a passion for the sea." |
*
* @param {Exp_Mk_Intro_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_intro_p2 = /** @type {((inputs?: Exp_Mk_Intro_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Intro_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_intro_p2(inputs)
	if (locale === "en") return en_exp_mk_intro_p2(inputs)
	return es_exp_mk_intro_p2(inputs)
});